import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as GroupsSelectors from '../../selectors/groups';
import * as CurrentsActions from '../../actions/current';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as CommentsSelectors from '../../selectors/comments';
import { EXTERNAL_GROUP_NAME, SELLER_GROUP_NAME } from '../../../Utils';
import PromptPendingComments from '../PendingPrompt';
import * as Translations from '../../providers/i18n';

import './style.scss';
import getGroupNameByType from './getGroupNameByType';
import GroupTabItem from './components/GroupTabItem';

export class CollaborationGroupsTabs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldShowPromptPendingComments: false
        };
    }

    setShouldShowPromptPendingComments = (value, groupId) => {
        this.setState({
            shouldShowPromptPendingComments: value,
            groupId
        });
    }

    handleOnClickOneGroup = () => {
        const {
            handlePlaceholderTabClick,
            pendingCommentsIdsLength
        } = this.props;

        if (!pendingCommentsIdsLength) {
            handlePlaceholderTabClick(true);
        } else {
            this.setShouldShowPromptPendingComments(true);
        }
    }

    handleOnClickNotOneGroup = (groupId) => {
        const {
            setCurrentGroupIdAndCurrentCollaboratorId,
            pendingCommentsIdsLength
        } = this.props;

        if (!pendingCommentsIdsLength) {
            setCurrentGroupIdAndCurrentCollaboratorId(groupId);
        } else {
            this.setShouldShowPromptPendingComments(true, groupId);
        }
    }

    render() {
        const {
            groups,
            handlePlaceholderTabClick,
            isPlaceholderTabClicked,
            setCurrentGroupIdAndCurrentCollaboratorId,
            senderInvitePermissions,
            i18n
        } = this.props;

        const {
            shouldShowPromptPendingComments,
            groupId
        } = this.state;

        if (!senderInvitePermissions) {
            // TODO: make this more explicit.
            // why should the collaborator see no tabs if he has no permissions to invite?
            // this is too ambiguous.
            return null;
        }
        const onlyOneGroup = groups.length === 1;

        if (onlyOneGroup) {
            return (
                <div className="groups-tabs">
                    <button className={classNames('tab', { selected: !isPlaceholderTabClicked })}
                        onClick={() => handlePlaceholderTabClick(false)}>
                        {getGroupNameByType(SELLER_GROUP_NAME, i18n)}
                    </button>
                    <button className={classNames('tab', { selected: isPlaceholderTabClicked })}
                        onClick={this.handleOnClickOneGroup}>
                        {getGroupNameByType(EXTERNAL_GROUP_NAME, i18n)}
                    </button>
                    <PromptPendingComments callback={() => handlePlaceholderTabClick(true)} shouldOpen={shouldShowPromptPendingComments} setShouldOpen={this.setShouldShowPromptPendingComments}/>
                </div>
            );
        }

        return (
            <div className="groups-tabs">
                <GroupTabItem type={SELLER_GROUP_NAME} onClick={this.handleOnClickNotOneGroup}/>
                <GroupTabItem type={EXTERNAL_GROUP_NAME} onClick={this.handleOnClickNotOneGroup}/>

                <PromptPendingComments callback={() => setCurrentGroupIdAndCurrentCollaboratorId(groupId)} shouldOpen={shouldShowPromptPendingComments} setShouldOpen={this.setShouldShowPromptPendingComments}/>
            </div>
        );
    }
}

CollaborationGroupsTabs.propTypes = {
    groups: PropTypes.array.isRequired,
    handlePlaceholderTabClick: PropTypes.func,
    setCurrentGroupIdAndCurrentCollaboratorId: PropTypes.func,
    isPlaceholderTabClicked: PropTypes.bool,
    senderInvitePermissions: PropTypes.bool,
    pendingCommentsIdsLength: PropTypes.number,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state) => ({
    groups: Object.values(GroupsSelectors.getGroups(state)),
    senderInvitePermissions: CollaboratorsSelectors.getCurrentCollaboratorInvitePermissions(state),
    pendingCommentsIdsLength: CommentsSelectors.getPendingIdsLength(state)
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentGroupIdAndCurrentCollaboratorId: (groupId) => dispatch(CurrentsActions.setCurrentGroupIdAndCurrentCollaboratorId(groupId))
});

export default compose(
    Translations.connect,
    connect(mapStateToProps, mapDispatchToProps))(CollaborationGroupsTabs);
